module.exports = __webpack_public_path__ + "img/ark4.d5d2b701.png";